// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".help-tab[data-v-399317b2] {\n  font-size: 0.75rem;\n  overflow: auto;\n}\n.help-tab .main-title[data-v-399317b2] {\n  font-size: 1.125rem;\n  font-weight: 500;\n}\n.help-tab .main-title > .link[data-v-399317b2] {\n  text-decoration: none;\n}\n.theme--light.help-tab[data-v-399317b2] {\n  background-color: #f6f6f6;\n}\n.theme--dark.help-tab[data-v-399317b2] {\n  background-color: #273039;\n}", ""]);
// Exports
module.exports = exports;
